import { FC } from "react";

import TableAdminUnloadingTemplate from "../../../components/table/unloadings/TableAdminUnloadingTemplate";

import styles from "./unloadingTemplate.module.scss";

const UnloadingTables: FC = () => {
  return (
    <div className={styles.wrapper}>
      <TableAdminUnloadingTemplate />
    </div>
  );
};

export default UnloadingTables;
